// src/pages/VendorLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/VendorLogin.css';
import authStorage from "../services/authStorage";
import { loginVendor } from "../services/authService";
const VendorLogin = () => {
  const navigate = useNavigate();
  const [companyCode, setCompanyCode] = useState('dh-pharm');
  const [email, setEmail] = useState('master@dh-pharm.com');
  const [password, setPassword] = useState('1234');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    const finalCompanyCode = companyCode.trim().toLowerCase();
    if (!finalCompanyCode) {
      setError('업체 코드를 입력해주세요.');
      return;
    }
    if (!email.trim()) {
      setError('아이디를 입력해주세요.');
      return;
    }

    loginVendor({
      companyCode: finalCompanyCode,
      email: email.trim(),
      password,
    })
      .then((data) => {
        authStorage.setUser(data.user);
        authStorage.setToken(data.token);
        navigate('/vendor/dashboard');
      })
      .catch((err) => {
        const msg = err.message || '';
        if (msg === 'Failed to fetch' || msg.includes('Load failed') || msg.includes('NetworkError')) {
          setError('서버에 연결할 수 없습니다. Render 서버가 켜지는 중일 수 있으니 1분 후 다시 시도해 주세요.');
        } else {
          setError(msg || '아이디 또는 비밀번호가 잘못되었습니다.');
        }
      });
  };

  return (
    <div className="vendor-login-bg">
      <form className="vendor-login-form" onSubmit={handleLogin}>
        <h2 className="vendor-login-title">도매업체 관리자 로그인</h2>

        <label className="vendor-login-label">업체 코드</label>
        <input
          type="text"
          value={companyCode}
          onChange={e => setCompanyCode(e.target.value)}
          required
          className="vendor-login-input"
          placeholder="예: dh-pharm"
          style={{ textTransform: 'lowercase' }}
        />

        <label className="vendor-login-label">아이디</label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className="vendor-login-input"
          placeholder="예: master@dh-pharm.com"
        />

        <label className="vendor-login-label">비밀번호</label>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          className="vendor-login-input"
        />

        {error && <div className="vendor-login-error">{error}</div>}

        <button type="submit" className="vendor-login-btn main">
          로그인
        </button>
        <button 
          type="button" 
          className="vendor-login-btn sub" 
          onClick={() => navigate('/hospital/login')}
        >
          병원 로그인으로
        </button>

      </form>
    </div>
  );
};

export default VendorLogin;
